const ArrowRight = ({ ...props }) => {
    return (
        <svg
            width="18"
            height="8"
            viewBox="0 0 18 8"
            fill="none"
            stroke="currentColor"
            {...props}
        >
            <g
                id="Symbols"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Footer"
                    transform="translate(-702.000000, -214.000000)"
                    fill="currentColor"
                >
                    <g id="Group-9">
                        <path
                            d="M710.930662,208.942516 C711.089575,208.942516 711.231991,209.017213 711.323925,209.13424 L714.650703,212.457442 C714.845563,212.653233 714.845563,212.970229 714.650703,213.166021 C714.453979,213.361813 714.136983,213.361813 713.940259,213.166021 L711.430484,210.659516 L711.431329,226.293384 C711.431329,226.563762 711.205703,226.796848 710.930662,226.796848 C710.653757,226.796848 710.42813,226.563762 710.42813,226.293384 L710.427484,210.651516 L707.914539,213.166021 C707.816643,213.268578 707.688912,213.315195 707.560249,213.315195 C707.432519,213.315195 707.302923,213.268578 707.205027,213.166021 C707.008303,212.970229 707.008303,212.653233 707.205027,212.457442 L710.571711,209.09169 L710.589235,209.076204 C710.604067,209.062465 710.619728,209.049615 710.636132,209.037736 L710.571711,209.09169 C710.596752,209.066774 710.624406,209.045188 710.653975,209.02693 C710.732854,208.973122 710.828251,208.942516 710.930662,208.942516 Z"
                            id="Arrow-Copy"
                            transform="translate(710.927166, 217.869682) scale(-1, 1) rotate(-90.000000) translate(-710.927166, -217.869682) "
                        />
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default ArrowRight
